import IssuePrioritizationStore from '../stores/issue-prioritization-store';

export const setLoading = (loading: boolean) => {
  IssuePrioritizationStore.loading = loading;
};

export const setError = (error: boolean) => {
  IssuePrioritizationStore.error = error;
};
